/* ==========================================================================
   The photo follows the choices

   Picking a collection, a lid or a ribbon was supposed to show the matching
   photograph. It did not, and the reason is the catalogue rather than the
   code: the gift jar carries images on 15 of its 36 variants and the biscotti
   on 9 of 117, so the combination a shopper lands on usually has no image of
   its own and the theme had nothing to swap in.

   So this does not ask for one exact image. It scores every photographed
   variant against what is currently chosen and shows the closest, which means
   a lid always shows its own lid even when that flavour and ribbon were never
   shot. The weights are what makes it read correctly: the lid (or the
   packaging, on the pages that call it Occasion) is the option the photograph
   is really of, the flavour comes next, and the ribbon is a detail. When
   nothing matches at all it leaves the gallery alone rather than putting up a
   photo of something else.

   It only ever reacts to a choice. On arrival the gallery's own first photo
   stands, which matters on the pages that deliberately start with nothing
   selected.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.gioVariantPhoto || {};
  var handle = CFG.handle || (window.ShopifyAnalytics && window.ShopifyAnalytics.meta &&
    window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.handle);
  if (!handle) return;

  var variants = null;
  var loading = null;

  function load() {
    if (variants) return Promise.resolve(variants);
    if (loading) return loading;
    loading = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var names = (data.options || []).map(function (o) { return (o && o.name) || o || ''; });
        variants = {
          names: names,
          weights: names.map(weightFor),
          shot: (data.variants || []).filter(function (v) { return v.featured_image; })
        };
        return variants;
      })
      .catch(function () {
        variants = { names: [], weights: [], shot: [] };
        return variants;
      });
    return loading;
  }

  /* What the photograph is mostly OF. A lid or a packaging shot is the picture;
     a flavour changes what is inside it; a ribbon is a detail on the same
     picture. Anything unrecognised sits in the middle. */
  function weightFor(name) {
    var n = String(name).toLowerCase();
    if (/lid|packag|occasion|vessel/.test(n)) return 8;
    if (/ribbon|bow|gift it/.test(n)) return 1;
    return 4;
  }

  /* What is chosen right now. Dawn's radios and selects are the truth: the
     card and dropdown bridges write to them, so reading them covers the custom
     controls too. The custom UI is read only where there is no picker at all. */
  function chosen(count) {
    var out = new Array(count).fill(null);
    var host = document.querySelector('variant-selects, variant-radios');

    if (host) {
      Array.prototype.forEach.call(host.querySelectorAll('fieldset'), function (set, i) {
        var hit = set.querySelector('input[type="radio"]:checked');
        if (hit && i < count) out[i] = hit.value;
      });
      Array.prototype.forEach.call(host.querySelectorAll('select'), function (sel, i) {
        if (!out[i] && i < count) out[i] = sel.value;
      });
    }

    if (!out[0]) {
      var flavor = document.querySelector('.fd-option.selected, .fd-option[aria-selected="true"]');
      if (flavor) out[0] = flavor.getAttribute('data-value');
    }
    var card = document.querySelector('.pkg-card.selected');
    if (card && !out[1]) out[1] = card.getAttribute('data-value');

    return out;
  }

  function best(map, picked) {
    var top = null;
    var topScore = 0;
    map.shot.forEach(function (v) {
      var score = 0;
      for (var i = 0; i < picked.length; i++) {
        if (picked[i] && v.options[i] === picked[i]) score += map.weights[i] || 1;
      }
      if (score > topScore) {
        topScore = score;
        top = v;
      }
    });
    return topScore ? top : null;
  }

  function label(map, picked) {
    var heaviest = -1;
    var text = '';
    for (var i = 0; i < picked.length; i++) {
      if (picked[i] && (map.weights[i] || 0) > heaviest) {
        heaviest = map.weights[i];
        text = picked[i];
      }
    }
    return text;
  }

  var last = '';
  var queued = false;

  function apply() {
    if (queued) return;
    queued = true;
    // After the click, not with it: the card and dropdown bridges write the
    // radios first, and this reads them.
    setTimeout(function () {
      queued = false;
      load().then(function (map) {
        if (!map.shot.length) return;
        var picked = chosen(map.names.length);
        var hit = best(map, picked);
        if (!hit || !hit.featured_image) return;

        var src = hit.featured_image.src || hit.featured_image;
        // Shopify's own size suffix, so the hero is not a thumbnail stretched.
        src = String(src).replace(/(\.[a-z]+)(\?|$)/i, '_1200x$1$2');
        if (src === last) return;
        last = src;

        if (typeof window.showVariantHero === 'function') {
          window.showVariantHero(src, label(map, picked));
          return;
        }
        var frame = document.querySelector('.hero-frame img');
        if (frame) frame.src = src;
      });
    }, 220);
  }

  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('variant-selects, variant-radios, .gio-ribbon, .fd-wrap')) apply();
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    if (event.target.closest('.fd-option, .pkg-card')) apply();
  });
})();
